export const setListaArquivosAction = listaArquivos => ({
  type: 'SET_LISTA_ARQUIVOS',
  listaArquivos
});
